import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/Common/FloatingBarWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/FooterLegal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/FooterSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/BookConsultationNow.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/Drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KarePediaLogo"] */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/KarePediaLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/NavCategoryDesktop.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/NotificationMob.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/NotificationSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/SearchMob.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/NavBar/compoents/SearchPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/first-project/mykare-blog-web/components/TostMessageCompoent.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":\"normal\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/footer/facebook-app-symbol.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/footer/instagram.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/footer/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/footer/twitter.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/footer/youtube.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/public/homePage/FeatureImage.webp");
